"use strict";

function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

$(document).ready(function () {

    $(window).on('action:app.loggedOut', function(event, data) {
        var service = window.location.href.split('?')[0];
        var url = `${config.CASServerPrefix}/logout?from=bbs&service=${service}`;
        console.log(`[action:app.loggedOut] data.next=${url}`);
        data.next = url;
    });

    var token = getCookie('token');
    console.log(token);

    if (app.user.uid) {
        console.log("logged in!");
    } else {
        console.log("not logged in!");

        if(token) {
            document.location.href = 'https://forum.labpano.com/cas/login?token=' + token;
        }
    }
});